import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import api from './api'
import http from './utils/request'
import {publicFn} from './utils/index.js'

import {
  Dialog,
  Empty,
  NavBar,
  Field,
  Button,
  Toast,
  RadioGroup,
  Radio,
  Form,
  Checkbox,
  Popup,
  Cell,
  ActionSheet,
  DatetimePicker
} from 'vant'

import 'amfe-flexible/index.js'
import Calendar from 'vue-mobile-calendar'
import './assets/css/reset.css'
import './assets/css/common.scss'

Vue.use(NavBar)
  .use(Field)
  .use(Button)
  .use(Toast)
  .use(RadioGroup)
  .use(Radio)
  .use(Checkbox)
  .use(Empty)
  .use(Dialog)
  .use(Popup)
  .use(Form)
  .use(Cell)
  .use(ActionSheet)
  .use(DatetimePicker)

Vue.prototype.$api = api
Vue.prototype.$http = http
Vue.prototype.$publicFn=publicFn

Vue.config.productionTip = false
Vue.use(Calendar)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
